@let currentLabelValue = currentLabel();
<div class="row">
  <div class="col">
    <h2 class="mt-3" [class]="titleClass()">
      <span>{{ titleText() }}</span>
      @if (currentLabelValue) {
        <cfp-info-modal-button
          class="ms-2"
          [title]="'info.energy-label-improvement.header'"
          [body]="infoModalBodyText()"
        />
      }
      <small>{{ 'improved.label.subtitle' | translate }}</small>
    </h2>
  </div>
  @let labelGroupsValue = labelGroups();
  @let labelGroupValue = labelGroup();
  @let isLoadingValue = isLoading();
  @let hasErrorValue = hasError();
  @if (!isLoadingValue && labelGroupsValue && canChangeLabelGroup()) {
    <div class="col-auto ms-auto d-flex flex-row d-print-none action-group">
      @if (!showLabelGroupsInDropdown()) {
        <cfp-select-label-group
          [labelGroup]="labelGroupValue"
          (labelGroupChange)="onLabelGroupChange($event)"
          [formControlSize]="'small'"
          [labelGroups]="labelGroupsValue"
          [dataTest]="'labelGroupSelect'"
          [name]="'labelImprovementLabelGroupSelect'"
        />
      } @else if (labelGroupsValue.length > 1) {
        <cfp-dropdown
          [icon]="'ellipsis-v'"
          [ariaLabel]="'selectLabelGroup' | translate"
          [id]="'selectLabelGroup'"
          [formControlSize]="'small'"
          class="cfp-dropdown-options"
          [container]="'body'"
        >
          <div class="dropdown-title">{{ 'rating' | translate }}</div>
          <cfp-radio-label-group
            [labelGroups]="labelGroupsValue"
            [labelGroup]="labelGroupValue"
            (labelGroupChange)="labelGroup.set($event)"
          />
          @if (showEnergyLabelDropdownOptions()) {
            <div class="divider dropdown-divider"></div>
            <ng-container [ngTemplateOutlet]="energyLabelDropdownOptionsTemplate" />
          }
        </cfp-dropdown>
      }
      @if (!showLabelGroupsInDropdown() && showEnergyLabelDropdownOptions()) {
        <cfp-dropdown
          class="cfp-dropdown-options index-range ms-2"
          [ariaLabel]="'epcDetails.dropdown.title' | translate"
          [id]="'select-index-range'"
          [icon]="'ellipsis-v'"
          [formControlSize]="'small'"
        >
          <ng-container [ngTemplateOutlet]="energyLabelDropdownOptionsTemplate" />
        </cfp-dropdown>
      }
    </div>
  }
</div>
<hr aria-hidden="true" />

<ng-template #energyLabelDropdownOptionsTemplate>
  @let showIndexRangeDropdownOptionsValue = showIndexRangeDropdownOptions();
  @if (showIndexRangeDropdownOptionsValue) {
    <div class="dropdown-title">{{ 'epcDetails.dropdown.title' | translate }}</div>
    <button type="button" class="dropdown-item w-100 m-0 d-inline-block" (click)="openIndexRange()">
      {{ 'epcDetails.dropdown.showIndexRange' | translate }}
    </button>
  }
  @let showEnergyLabelHistoryOptionValue = showEnergyLabelHistoryOption();
  @let showRegisteredLabelForImprovedLabelValue = showRegisteredLabelForImprovedLabel();
  @if (showEnergyLabelHistoryOptionValue || showRegisteredLabelForImprovedLabelValue) {
    @if (showIndexRangeDropdownOptionsValue) {
      <div class="divider dropdown-divider"></div>
    }
    <div class="dropdown-title">{{ 'energyLabel.dropdown.title' | translate }}</div>
    @if (showEnergyLabelHistoryOptionValue) {
      <button type="button" class="dropdown-item w-100 m-0 d-inline-block" (click)="openEnergyLabelHistory()">
        {{ 'energyLabelHistory.title' | translate }}
      </button>
    }
    @if (showRegisteredLabelForImprovedLabelValue) {
      <button
        type="button"
        class="dropdown-item w-100 m-0 d-inline-block"
        (click)="useRegisteredLabelForImprovedLabel(false)"
      >
        {{ 'energylabel.improvement.useCalculatedLabel' | translate }}
      </button>
    }
  }
</ng-template>

<cfp-loading-spinner [loading]="isLoadingValue" [error]="hasErrorValue" />

@let buildingValue = building();
@let buildingLabelValue = buildingLabel();
@if (!isLoadingValue && !hasErrorValue && buildingValue) {
  <div data-test="labelImprovement">
    @if (buildingLabelValue) {
      <!-- Label Improvement -->
      @if (labelGroupValue) {
        <div>
          <div class="row align-items-center">
            <div class="col">
              <cfp-energy-label
                [attr.aria-label]="currentLabelText()"
                [energyLabel]="currentLabelValue"
                [labelSituationType]="buildingLabelValue.labelSituationType"
                data-test="energyLabelCurrent"
              />
              <div class="fw-bold mt-3">
                {{ currentLabelText() }}
              </div>
            </div>
            <div class="col-auto text-center">
              <cfp-icon
                [icon]="'long-arrow-right'"
                [iconSize]="'large'"
                [classes]="'text-muted'"
                [ariaLabel]="'aria.label.to' | translate"
              />
              <div class="mt-3">&nbsp;</div>
            </div>
            <div class="col">
              <cfp-energy-label
                [attr.aria-label]="improvedLabelText()"
                [energyLabel]="improvedLabel()"
                data-test="energyLabelImproved"
              />
              <div class="fw-bold mt-3">
                {{ improvedLabelText() }}
              </div>
            </div>
          </div>
        </div>
      }
      <!-- /Label Improvement -->

      @let crremLabelValue = crremLabel();
      @if (crremLabelValue && isCrremTranslationLoaded()) {
        <div
          class="mt-4"
          [innerHtml]="
            'crrem.targetBuilding2050'
              | translate: { target: crremLabelValue.totalCo2ConsumptionTarget2050 | number: '1.0-2' }
          "
        ></div>
      }

      @let improvedLabelValue = improvedLabel();
      @if (labelGroupValue === LabelGroupDTO.WEII && currentLabelValue && improvedLabelValue && buildingValue) {
        @defer {
          <div class="mt-4">
            <cfp-weii-improvement-scale
              [currentLabel]="currentLabelValue"
              [improvedLabel]="improvedLabelValue"
              [building]="buildingValue"
            />
          </div>
        }
      }

      <!-- Label Improvement Alert -->
      @if (
        !registeredLabel() &&
        !showRefineBuildingCharacteristics &&
        (currentLabelValue?.indexType === IndexTypeDTO.EI || currentLabelValue?.indexType === IndexTypeDTO.EP2)
      ) {
        <small class="text-muted">
          <hr class="d-block" />
          {{ 'energylabelrvo' | translate }}
          @if ('energylabel.improvement.register.text' | translate) {
            <cfp-translated-router-link
              class="d-print-none"
              (linkClick)="showContactModal()"
              [text]="'energylabel.improvement.register.text'"
            />
          }
          <div class="d-none d-print-block mt-3 fw-bold">
            <a href="mailto: info@cfp.nl"><i class="fa fa-envelope me-2"></i>info&#64;cfp.nl</a>
            <a href="https://www.cfp.nl" class="ms-4"><i class="fa fa-globe me-2"></i>www.cfp.nl</a>
          </div>
        </small>
      }
      @if (!currentLabelValue?.registrationDate && showRefineBuildingCharacteristics) {
        <small>
          <hr class="d-block" />
          {{ 'labelImprovement.estimatedRating' | translate }}
          <div class="fw-bold">
            <a [routerLink]="`/energy/${buildingValue.portfolio!.id}/buildings/${buildingValue.id}/properties`">
              {{ 'refineBuildingCharacteristics' | translate }}
              <cfp-icon [icon]="'chevron-right'" [classes]="'ms-2'" />
            </a>
          </div>
        </small>
      }
      @if (currentLabelValue && currentLabelValue.registrationDate) {
        <small class="text-muted d-print-none">
          @if (!clarificationText()) {
            <hr class="d-block" />
            <div
              [innerHtml]="
                `improved.label.info.certified.${labelGroupValue}`
                  | translate
                    : {
                        label: translatedRegisteredLabel(),
                        date: currentLabelValue.validUntil ? (currentLabelValue.validUntil | date: 'longDate') : ''
                      }
              "
            ></div>
          }
          @if (isExpired()) {
            <div class="text-danger mt-2">
              <i class="fas fa-exclamation-circle me-2" aria-hidden="true"></i
              >{{
                'energy.label.expired'
                  | translate
                    : {
                        labelGroupRating: `labelGroup.rating.${labelGroupValue}` | translate
                      }
              }}
            </div>
            @if (currentLabelValue.indexType === IndexTypeDTO.EI || currentLabelValue.indexType === IndexTypeDTO.EP2) {
              <div>
                <button type="button" (click)="showContactModal()" class="btn btn-primary mt-3">
                  {{ 'energylabel.improvement.register' | translate }}
                </button>
              </div>
            }
          }
        </small>
      }
      @let clarificationLabelValue = clarificationLabel();
      @let showlabelSituationTypeValue = showlabelSituationType();
      @if (showlabelSituationTypeValue && clarificationLabelValue) {
        <small class="text-muted d-print-none">
          <hr class="d-block" />
          <div class="row">
            <div class="col-auto">
              <cfp-energy-label
                [energyLabel]="clarificationLabelValue"
                [labelSituationType]="buildingLabelValue.labelSituationType"
              />
            </div>
            <div class="col">
              <div [innerHTML]="clarificationText()"></div>
            </div>
          </div>
        </small>
      }
      @if (
        showlabelSituationTypeValue &&
        buildingLabelValue.labelSituationType === EnergyLabelSituationTypeDTO.CALCULATEDLABELISBETTERTHANREGISTERED
      ) {
        <hr class="d-block" />
        <cfp-alert [alertStyle]="'warning'" [icon]="'circle-exclamation'" [iconSize]="'large'" [hasAccent]="true">
          <h6>{{ 'energylabel.improvement.useRegisteredLabelTitle' | translate }}</h6>
          <p class="small">
            {{ 'energylabel.improvement.useRegisteredLabelExplanation' | translate }}
          </p>
          <cfp-button
            (clicked)="useRegisteredLabelForImprovedLabel(true)"
            [buttonOutline]="true"
            [buttonStyle]="'secondary'"
          >
            {{ 'energylabel.improvement.useRegisteredLabel' | translate }}
          </cfp-button>
        </cfp-alert>
      }
      <!-- /Label Improvement Alert -->

      @if (
        (currentLabelValue?.registrationDate && currentLabelValue?.indexType === IndexTypeDTO.EI) ||
        (clarificationLabelValue?.registrationDate && clarificationLabelValue?.indexType === IndexTypeDTO.EI)
      ) {
        <cfp-alert
          [alertStyle]="'warning'"
          [icon]="'circle-exclamation'"
          [iconSize]="'large'"
          [hasAccent]="true"
          [classes]="'mt-4 d-print-none'"
        >
          <h6>{{ 'energylabel.improvement.oldMethodologyTitle' | translate }}</h6>
          <p class="small">
            {{ 'energylabel.improvement.oldMethodologyText' | translate }}
          </p>
          <cfp-button [buttonStyle]="'secondary'" [buttonOutline]="true" (clicked)="showOldMethodologyModal()">{{
            'energylabel.improvement.oldMethodologyButton' | translate
          }}</cfp-button>
        </cfp-alert>
      }

      <!-- Monument -->
      @if (
        labelGroupValue === LabelGroupDTO.EPC &&
        buildingValue.address?.monument &&
        buildingValue.objectType !== ObjectTypeDTO.PARKING
      ) {
        <small class="text-muted">
          <hr class="d-block" />
          <div class="row">
            <div class="col-auto">
              <cfp-energy-label [energyLabel]="{ label: 'monument' }" />
            </div>
            <div class="col">
              {{ 'monumentText' | translate }}
              <div class="d-print-none">
                <button type="button" (click)="showContactModal()" class="btn btn-primary mt-3">
                  {{ 'energylabel.improvement.requestAdvice' | translate }}
                </button>
              </div>
            </div>
          </div>
        </small>
      }
      <!-- /Monument -->
    }

    <!-- Parking -->
    @if (!labelGroupValue && buildingValue.objectType === ObjectTypeDTO.PARKING) {
      <div class="text-center pt-3">
        <cfp-energy-label class="d-inline-block" [energyLabel]="{ label: 'parking' }" />
        <div class="mt-5">
          {{ 'parkingText' | translate }}
        </div>
      </div>
    }
    <!-- /Parking -->

    @if (canManuallyChangeLabel()) {
      <cfp-button
        class="d-block mt-4 d-print-none"
        [buttonStyle]="'secondary'"
        [buttonOutline]="true"
        (clicked)="showManualEnergyLabelModal()"
      >
        {{ 'manualEnergyLabel.change' | translate }}
      </cfp-button>
    }

    @if (canManuallyRegisterLabel()) {
      <cfp-button
        class="d-block mt-4 d-print-none"
        [buttonStyle]="'secondary'"
        [buttonOutline]="true"
        (clicked)="showRegisteredEneryLabelModal()"
      >
        {{ (registeredLabel() ? 'registeredEnergyLabel.edit' : 'registeredEnergyLabel.add') | translate }}
      </cfp-button>
    }
  </div>
}
